import PaymentCalculatorForm from './PaymentCalculatorForm.js';

const paymentCalculatorForm = new PaymentCalculatorForm('js-calc-form');
if (paymentCalculatorForm.element) {
  paymentCalculatorForm.element.addEventListener('change', function (event) {
    // Handle financing term select/dropdown selection
    // TODO: Consider making all term fields a dropdown
    if (event.target.name === 'finance_term' && event.target.nodeName === 'SELECT') {
      paymentCalculatorForm.financeElements.rate.value =
        event.target.options[event.target.selectedIndex].dataset.rate;
    }
  });
}
